// extracted by mini-css-extract-plugin
export default {"container":"Home_container__AHomM","content":"Home_content__aDyUb"};